var _rect, _mask, _g, _mask2, _g2, _path, _mask3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamesSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "str3wk61ca",
    width: 10,
    height: 9,
    x: 10,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.256 10h9.08v8.858h-9.08V10z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#str3wk61ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M12.454 18.858h4.684c1.212 0 2.198-.986 2.198-2.2v-4.46c0-1.212-.986-2.198-2.198-2.198h-4.684c-1.211 0-2.198.986-2.198 2.199v4.46c0 1.213.987 2.199 2.198 2.199z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "lxx0wszzdb",
    width: 10,
    height: 9,
    x: 21,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.562 10h9.081v8.858h-9.08V10z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lxx0wszzdb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M26.103 18.858c2.503 0 4.54-1.987 4.54-4.43 0-2.442-2.037-4.428-4.54-4.428s-4.54 1.986-4.54 4.429c0 2.442 2.037 4.429 4.54 4.429z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M19.529 20.713c-.37-.38-.978-.39-1.356-.02l-3.273 3.18-3.272-3.18c-.377-.37-.985-.36-1.357.02-.368.379-.36.987.02 1.356l3.233 3.142-3.232 3.142c-.381.369-.39.977-.021 1.356.189.193.439.29.689.29.24 0 .482-.09.668-.27l3.272-3.181 3.273 3.18c.185.182.427.272.668.272.25 0 .5-.098.688-.291.369-.38.36-.987-.02-1.356l-3.233-3.142 3.233-3.142c.38-.37.389-.977.02-1.356z",
    clipRule: "evenodd"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "r7mcuq5lic",
    width: 10,
    height: 10,
    x: 21,
    y: 20,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.795 20.882h8.848v8.632h-8.848v-8.632z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r7mcuq5lic)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M30.042 20.961c-.373-.157-.797-.077-1.082.202l-6.866 6.673c-.287.278-.376.695-.227 1.063.152.374.513.615.918.615h6.868c.546 0 .99-.439.99-.978v-6.675c0-.393-.236-.746-.601-.9z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesSmall);
export default __webpack_public_path__ + "static/media/games_small.1a351e8ddf2e059f1a59c4dd52c0a2f7.svg";
export { ForwardRef as ReactComponent };